import axios from 'axios';
import { agentStore } from '../../store/index';//../store/index
import {AGENT_BASE_URL} from '../../../config';

//const BASE_URL = 'http://127.0.0.1:3000/agent';
//const BASE_URL = 'https://www.dreasyfly.in/agent';


const apiClient = axios.create({
	baseURL: AGENT_BASE_URL,
	headers: {
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*'
	},
}); 
apiClient.interceptors.request.use( 
	async (config) => {
		try {
			const authStore = agentStore();
			const token = authStore.token;
			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
				// config.timeout = 30000;
			}
		} catch (error) {
			console.error('Error fetching token:', error);
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

//let InterNalErr = { "status": 0, "errors": ["Internal Server Error"], "message": "" };
let InterNalErr = {
    status: 0,
    errors: "Internal Server Error",
    message: "Server is offline. Please try again later"
};
export default {
	async fetchData() {
		const response = await apiClient.get('/');
		return response.data;
	},
	async login(email, password) {
		const requestData = { email, password };
		try {
			const response = await apiClient.post('/login', requestData);
			return response.data;
		} catch (error) {
			if (error.response) {
				return error.response.data;
			} else {
				return InterNalErr;
			}
		}
	},
	async getAgentBalance() {
		try {
			const resp = await apiClient.get("/get-balance");
			return resp.data;
		} catch (error) {
			if (error.response) {
				return error.response.data;
			} else {
				return InterNalErr;
			}
		}
	},
	async logout() {
		try {
			const response = await apiClient.post('/logout');
			return response.data;
		} catch (error) {
			if (error.response) {
				return error.response.data;
			} else {
				return 'InternalErr';
			}
		}
	},






};
